import { render } from "./SoilTest.vue?vue&type=template&id=46c3dde6"
import script from "./SoilTest.vue?vue&type=script&lang=js"
export * from "./SoilTest.vue?vue&type=script&lang=js"

import "./SoilTest.vue?vue&type=style&index=0&id=46c3dde6&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__